export enum SidewallAngleType {
  At90 = 'at90', // 90 degrees from sidewall roof surface
  Vertical = 'vertical', // vertical from the ground
  Mitre = 'mitre', // mitred with the next roof surface
}
